import { reduce } from 'lodash';

type Queryables = {
  width: number;
};

type ParsedQuery = {
  [key: string]: number;
};

export const parseQuery = (query: string): ParsedQuery => {
  // Only works for `and` queries for now.
  const parts = query
    .split('and')
    .map((part) => part.trim())
    // Remove parentheses
    .map((part) => part.replace(/[()]/g, ''));
  return parts.reduce((accum: ParsedQuery, part: string) => {
    const [key = '', val = ''] = part.split(':');
    accum[key.trim()] = parseInt(val, 10);
    return accum;
  }, {});
};

const doesQueryMatch = (queryables: Queryables, query: ParsedQuery) => {
  return [
    queryables.width >= (query['min-width'] || 0),
    queryables.width <= (query['max-width'] || Infinity),
  ].every(Boolean);
};

type Queries = Array<string>;
type QueryResults = {
  [key: string]: boolean;
};
export const findMatchingQueries = (
  queryables: Queryables,
  queries: Queries
) => {
  return reduce(
    queries,
    (accum: QueryResults, queryToCheck) => {
      const mediaQuery = queryToCheck;
      const parsedQuery = parseQuery(mediaQuery);
      accum[queryToCheck] = doesQueryMatch(queryables, parsedQuery);
      return accum;
    },
    {}
  );
};

export default findMatchingQueries;
